export const DOMAIN_PLACEHOLDER = 'domain.placeholder.com'
